import React from 'react'
import { useTranslation } from 'react-i18next'
import {Typography, Spin} from 'antd'
import {observer} from 'mobx-react'
import {Modal} from '@/components'
import {LoadingOutlined} from '@ant-design/icons'
import {SettlementsPdfDownloadLoadingModalProps} from './props'

import styles from './styles.scss'
import { LOADING } from '@/constants/playwright-ids'

export const SettlementsPdfDownloadLoadingModal = observer(
    ({isOpen, onCancel}: SettlementsPdfDownloadLoadingModalProps) => {
        const { t } = useTranslation()
        return (
            <Modal
                width={'408px'}
                open={isOpen}
                footer={null}
                centered={true}
                onCancel={onCancel}
                closable={false}
            >
                <div className={styles.spinHolder} data-test-id={LOADING}>
                    <Spin indicator={<LoadingOutlined className={styles.loadingIcon} spin />} />
                </div>

                <Typography.Title level={5} className={styles.title}>
                    {t('SettlementsPdfDownloadLoadingModal.title')}
                </Typography.Title>
                <Typography.Text className={styles.text}>{t('SettlementsPdfDownloadLoadingModal.text')}</Typography.Text>
            </Modal>
        )
    }
)
